export default __webpack_public_path__ + "static/media/line_tooth.4bde5fee.png";